import "./publicPath";

// import react polyfill
import { Provider } from "react-redux";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "./services/IntlRedux";

// Import App Components
import App from "./App";
import "./index.css";
import "./services/AxiosMiddleware";

// Sentry integration
// import './services/sentry';

// Import Ant Design 5 reset CSS (Antd 5 uses CSS-in-JS, but reset.css provides base styles)
// Note: Antd 5 no longer needs the full CSS import - components use CSS-in-JS
import "antd/dist/reset.css";

// TODO need to figure out why we need this file (there are some global styles and antd overrides)
// import "./assets/less/ant.css";

// Import styles
import "./assets/styles/main.css";

import config from "./constants/Configs";
import store from "./store";
import { getAppBasePath, getAppPathname } from "./services/AppBasePath";
import { RoutePath } from "./constants/SitePaths";
import { registerStaticTheme } from "./theme/registerStaticTheme";

// Static AntD holders (Modal.confirm/message/notification) must carry the same
// CU theme as the mounted ConfigProvider - registered once, before any render.
registerStaticTheme();

store.subscribe(() => {
	// localStorage.setItem('saved_store_state', JSON.stringify(store.getState()));
});

// Create React root once
const target = document.querySelector("#root");
const root = createRoot(target);

// App wrapper with providers
const AppWrapper = () => (
	<Provider store={store}>
		<IntlProvider>
			<App />
		</IntlProvider>
	</Provider>
);

// Create the router with the App component
const router = createBrowserRouter(
	[
		{
			path: "*",
			element: <AppWrapper />,
		},
	],
	{
		basename: getAppBasePath() || "/",
	},
);

// IF SSO IS NOT ENABLED CASE
if (!config.IS_SSO_ENABLED) {
	root.render(<RouterProvider router={router} />);
}
// IF SSO IS ENABLED CASE
else {
	let isLoading = true;
	const platLoginURL = config.PLATH_LOGIN_URL;

	const recieveMsg = message => {
		try {
			if (getAppPathname() === RoutePath.LOGIN) {
				console.log("/login");
				window.location.href = platLoginURL;
			}

			if (message && message.data && typeof message.data === "string") {
				const data = JSON.parse(message.data);
				console.log(data);
				if (data.method === "remove") {
					window.location.href = platLoginURL;
				} else if (data.method === "add") {
					localStorage.setItem(data.key, JSON.stringify(data.data));
					isLoading = false;
					// Clean up event listener before rendering
					window.removeEventListener("message", recieveMsg);
					root.render(<RouterProvider router={router} />);
				}
			}
		} catch (e) {
			console.log(e);
		}
	};

	window.addEventListener("message", recieveMsg);

	// Add auth iframe to the page
	const iframe = document.createElement("iframe");
	iframe.style.height = "1px";
	iframe.style.width = "1px";
	iframe.style.position = "absolute";
	iframe.style.top = 0;
	iframe.style.border = 0;
	iframe.id = "account-frame";
	iframe.src = config.AUTH_IFRAME_URL;
	document.body.appendChild(iframe);

	// Timeout fallback - redirect to login if no response
	setTimeout(() => {
		if (isLoading) {
			console.log("SSO timeout - redirecting to login");
			window.removeEventListener("message", recieveMsg);
			window.location.href = platLoginURL;
		}
	}, 20000);
}
